import { createFileRoute } from "@tanstack/react-router";

import { LANGS, dictionaries } from "@/content/site";

export const Route = createFileRoute("/sitemap.xml")({
  server: {
    handlers: {
      GET: async ({ request }) => {
        const origin = new URL(request.url).origin;
        const today = new Date().toISOString().split("T")[0];
        const paths = new Set<string>(["", "/divisions", "/beyond-sourcing", "/faq", "/privacy", "/terms", "/how-we-work", "/manufacturing-network", "/markets", "/about", "/contact", "/rfq", "/rfq/spare-parts", "/rfq/custom-manufacturing", "/rfq/turnkey-project"]);
        for (const d of dictionaries.en.divisions) paths.add(`/divisions/${d.slug}`);
        for (const m of dictionaries.en.markets) paths.add(`/markets/${m.slug}`);
        const urls: string[] = [];
        for (const path of paths) {
          for (const lang of LANGS) {
            const alternates = LANGS.map(
              (l) => `    <xhtml:link rel="alternate" hreflang="${l}" href="${origin}/${l}${path}" />`,
            ).join("\n");
            urls.push(
              [
                "  <url>",
                `    <loc>${origin}/${lang}${path}</loc>`,
                alternates,
                `    <lastmod>${today}</lastmod>`,
                `    <changefreq>${path === "" ? "weekly" : "monthly"}</changefreq>`,
                `    <priority>${path === "" ? "1.0" : path.startsWith("/markets/") || path.startsWith("/divisions/") ? "0.8" : "0.6"}</priority>`,
                "  </url>",
              ].join("\n"),
            );
          }
        }
        const xml = [
          '<?xml version="1.0" encoding="UTF-8"?>',
          '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">',
          ...urls,
          "</urlset>",
        ].join("\n");
        return new Response(xml, {
          headers: {
            "Content-Type": "application/xml; charset=utf-8",
            "Cache-Control": "public, max-age=3600",
          },
        });
      },
    },
  },
});
